
export default {
  data() {
    return {
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      keyword: "",
      postTypeSlugs: "",
      searchTerm: "",
    };
  },
  computed: {
    page() {
      return this.pagination.page;
    },
  },
  watch: {
    page() {
      this.search();
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.posttype) {
      this.postTypeSlugs = this.$route.query.posttype;
    }
    if (this.$route.query && this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
      this.searchTerm = this.keyword;
      this.search();
    }
  },
  methods: {
    async search() {
      this.loading = true;
      try {
        const body = {
          keywords: this.keyword,
          page: this.pagination.page,
          limit: 12,
          filters: [
            {
              key: "archived",
              value: false,
              default: true,
            },
            {
              key: "postTypeSlugs",
              value: [this.postTypeSlugs],
            },
            {
              key: "state",
              value: true,
            },
          ],
          list: false,
        };
        await this.$axios
          .post("/api/v1/cms/post/filterStandard", body)
          .then((res) => {
            if (res && res.data.data) {
              this.results = res.data.data.data;
              this.pagination = res.data.data.pagination;
            }
            if (!this.keyword) {
              this.results = [];
            }
            this.loading = false;
            this.init = false;
          });
      } catch (e) {}
      this.loading = false;
    },
    async supportSearch() {
      await this.$router.push({
        query: {
          posttype: "helpdesk",
          keyword: this.keyword,
        },
      });
      this.searchTerm = this.keyword;
      this.search();
    },
    goBack() {
      if (this.$i18n.locale === "en") {
        this.$router.push({
          path: "/helpdesk",
          query: {
            posttype: "helpdesk",
          },
        });
      } else {
        this.$router.push({
          path: "tehnicka-podrska",
          query: {
            posttype: "tehnicka-podrska",
          },
        });
      }
    },
  },
};
